/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Availability status for a timeslot.
 * @export
 * @enum {string}
 */

export enum AvailabilityStatus {
    Available = 'available',
    NoLongerAvailable = 'no_longer_available',
    BookedByYou = 'booked_by_you',
    BookedByOther = 'booked_by_other',
    Closed = 'closed',
    NotAllowed = 'not_allowed'
}



